import * as Yup from 'yup';

const validationSchema = Yup.object()
    .shape({
        GooglePlaceLookup: Yup.string().required(),
    })
    .required();

export { validationSchema };
